import {
  RouterBackRequest,
  RouterForwardRequest,
  RouterRequest,
  RouterRequestError,
  RouterRequestFulfilled,
  RouterRequestRejected,
} from 'app/core/browser/state/actions/index';

export { RouterRequestActionType } from './router-request-action-type.enum';
export { RouterBackRequest } from './router-back-request.action';
export { RouterForwardRequest } from './router-forward-request.action';
export { RouterRequest } from './router-request.action';
export { RouterRequestError } from './router-request-error.action';
export { RouterRequestFulfilled } from './router-request-fulfilled.action';
export { RouterRequestRejected } from './router-request-rejected.action';

export type RouterRequestActions =
  RouterRequest |
  RouterBackRequest |
  RouterForwardRequest |
  RouterRequestFulfilled |
  RouterRequestRejected |
  RouterRequestError;
